export let resetFolderToInbox = "oq4XNd";
export let windowTitleModuleUserFormatString = "LJemPe";
export let mailModuleTitle = "r2x6ad";
export default {resetFolderToInbox,windowTitleModuleUserFormatString,mailModuleTitle};